"use client";

import React from "react";
import QueryString from "query-string";
import { Box, Button, EmptyState, Text, useClientValue } from "@thenounproject/lingo-core";

export default function NotFoundPage() {
  const next = useClientValue(() => {
    return QueryString.stringify({ next: window.location.toString() });
  });

  const subtext = (
    <Text color="grayDarkest" mt="xxl">
      Do you need to <Button text="log in" buttonStyle="tertiary" link={`/login/?${next}`} /> to a
      different account?
    </Text>
  );
  return (
    <Box pt="25vh">
      <EmptyState
        title="We couldn't find what you are looking for"
        subtitle="Please check the link you followed and try again."
        size="large"
        extra={subtext}
      />
    </Box>
  );
}
